import React from 'react';
import { Reveal } from '../Reveal';
import { Button } from '../Button';
import { results, studyDesign } from '../../data/study';
import { useLayout } from '../../contexts/LayoutContext';
type StudyContextScreenProps = {
  onNext: () => void;
};
export function StudyContextScreen({
  onNext
}: StudyContextScreenProps) {
  const {
    compact,
    wide
  } = useLayout();
  const cta = <Button fullWidth={compact} onClick={onNext} data-id="element-179" data-mp="jbkjv31za0do">
      See the result
    </Button>;
  return <div className={`flex min-h-full flex-col ${compact ? 'py-6' : 'justify-center py-10'}`} data-id="element-180" data-mp="ecr7xf2cahfm">
      <div className={wide ? 'grid grid-cols-2 items-center gap-24' : 'flex flex-col'} data-id="element-181" data-mp="t1dvu5618hig">
        <div data-id="element-182" data-mp="t36uax6hrvfd">
          <Reveal data-id="element-183" data-mp="o2j60j9ndsou">
            <h2 className={`max-w-lg font-display font-light tracking-[-0.03em] text-ink ${compact ? 'text-[2.1rem] leading-[1.08]' : 'text-5xl leading-[1.05]'}`} data-id="element-184" data-mp="o211z0gqua6d">
              A Phase 3 study in patients with IPF
            </h2>
          </Reveal>
          <Reveal delay={0.08} data-id="element-185" data-mp="h5s460zajn54">
            <dl className={`${compact ? 'mt-6' : 'mt-10'} max-w-lg divide-y divide-hairline rounded-2xl bg-surface`} data-id="element-186" data-mp="h6jt4sydummf">
              {studyDesign.map(item => <div key={item.label} className={`flex items-baseline justify-between gap-6 ${compact ? 'px-5 py-4' : 'px-6 py-5'}`} data-id="element-187" data-mp="r1v5x5q8djrj">
                  <dt className="text-sm text-muted" data-id="element-188" data-mp="104cuhqtcyohp">{item.label}</dt>
                  <dd className="text-right text-[15px] font-medium text-ink" data-id="element-189" data-mp="152o3y0fqqwze">{item.value}</dd>
                </div>)}
            </dl>
          </Reveal>
          {wide && <Reveal delay={0.4} data-id="element-190" data-mp="19vqnrgupus2e">
              <div className="mt-10" data-id="element-191" data-mp="1et0ohsnk2q5j">{cta}</div>
            </Reveal>}
        </div>

        <Reveal delay={0.22} data-id="element-192" data-mp="1js3r76g2ckac">
          <div className={wide ? 'border-l border-hairline pl-12' : compact ? 'mt-10 border-t border-hairline pt-8' : 'mt-14 border-t border-hairline pt-10'} data-id="element-193" data-mp="1jsvapiwdyrk9">
            <p className={`font-display font-light leading-none tracking-[-0.045em] tabular-nums text-ink ${compact ? 'text-[5.75rem]' : 'text-[9.5rem]'}`} data-id="element-194" data-mp="3fvhxbdirplar">
              {results.backgroundAntifibroticPct}
              <span className="text-[0.45em] text-accent" data-id="element-195" data-mp="3otk8glw7tubr">%</span>
            </p>
            <p className={`mt-5 max-w-sm leading-relaxed text-muted ${compact ? 'text-lg' : 'text-xl'}`} data-id="element-196" data-mp="7gzw9vr8v60n">
              were already receiving nintedanib or pirfenidone at baseline
            </p>
          </div>
        </Reveal>
      </div>

      {!wide && <Reveal delay={0.4} className={compact ? 'mt-auto pt-10' : 'mt-12'} data-id="element-197" data-mp="cf1eyfkrd3bl">
          {cta}
        </Reveal>}
    </div>;
}